module.exports = __webpack_public_path__ + "img/4c77939.png";